/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfReport } from '../../models/data-page-of-report';

export interface ReportsGet$Params {
  pageSize?: number;
  pageNumber?: number;
  reportCategoryId?: number;
}

export function reportsGet(http: HttpClient, rootUrl: string, params?: ReportsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReport>> {
  const rb = new RequestBuilder(rootUrl, reportsGet.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('reportCategoryId', params.reportCategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfReport>;
    })
  );
}

reportsGet.PATH = '/api/Reports/report/list';
